import { ListItemButton, Divider, Typography } from '@mui/material'
import { Stack, Box } from '@mui/system'
import CircleIcon from '@mui/icons-material/Circle'
import { NodeRendererProps } from 'react-arborist'

// TODO: Remove any type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface IAccountPannelTreeNodeProps extends NodeRendererProps<any> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedNode: any
}

function AccountPanelTreeNode({ node, style, selectedNode }: IAccountPannelTreeNodeProps) {
  if (node.level > 0) {
    return (
      <Box style={style}>
        <ListItemButton
          disableGutters
          sx={{
            py: 0
          }}
          onClick={() => node.activate()}
        >
          <Stack alignItems="center" direction="row" sx={{ height: '32px', width: '100%' }}>
            <Stack sx={{ height: '100%' }}>
              <Box
                sx={{
                  flex: 1,
                  borderLeft: 'solid 1px',
                  borderLeftColor: 'border.primary'
                }}
              />
              <Divider sx={{ width: '8px', color: 'border.primary' }} />
              <Box
                sx={{
                  flex: 1,
                  borderLeft: node.nextSibling ? 'solid 1px' : 'none',
                  borderLeftColor: 'border.primary'
                }}
              />
            </Stack>
            <Stack
              gap={1}
              alignItems="center"
              direction="row"
              sx={{
                pl: 1,
                height: '100%',
                width: '100%',
                fontWeight: 400,
                ...(selectedNode?.id === node.id
                  ? { ml: 1, fontWeight: 500, background: '#F6F7F8', borderRadius: '6px' }
                  : {}),
                '&:hover': {
                  backgroundColor: '#F6F7F8'
                }
              }}
            >
              <CircleIcon
                sx={{
                  fontSize: '10px',
                  color: node.data.data.availableColor
                }}
              />
              <Typography
                sx={{
                  color: 'content.primary',
                  fontSize: '12px',
                  lineHeight: '18px',
                  fontWeight: 'inherit'
                }}
              >
                {node.data.name}
              </Typography>
            </Stack>
          </Stack>
        </ListItemButton>
      </Box>
    )
  }
  return (
    <Box style={{ ...style, display: 'flex', alignItems: 'center' }}>
      <Typography
        sx={{
          color: 'content.primary',
          fontSize: '12px',
          lineHeight: '18px',
          fontWeight: 500
        }}
      >
        {node.data.name}
      </Typography>
    </Box>
  )
}

export default AccountPanelTreeNode
